import { render, staticRenderFns } from "./VolCalc.vue?vue&type=template&id=6ba56494&scoped=true&"
import script from "./VolCalc.vue?vue&type=script&lang=js&"
export * from "./VolCalc.vue?vue&type=script&lang=js&"
import style0 from "./VolCalc.vue?vue&type=style&index=0&id=6ba56494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba56494",
  null
  
)

export default component.exports